// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#deleteBrModal p {
  margin-bottom: 0;
}
#deleteBrModal .container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
#deleteBrModal {
  /* Create a custom checkbox */
}
#deleteBrModal .checkmark {
  position: absolute;
  top: 15px;
  margin-left: -15px;
  height: 20px;
  width: 20px;
  border: 2px solid #d0d0d0;
  border-radius: 4px;
}
#deleteBrModal {
  /* When the checkbox is checked, add a blue background */
}
#deleteBrModal .container input:checked ~ .checkmark {
  background-color: #2196F3;
  border: 2px solid #2196F3;
}
#deleteBrModal {
  /* Create the checkmark/indicator (hidden when not checked) */
}
#deleteBrModal .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
#deleteBrModal {
  /* Show the checkmark when checked */
}
#deleteBrModal .container input:checked ~ .checkmark:after {
  display: block;
}
#deleteBrModal {
  /* Style the checkmark/indicator */
}
#deleteBrModal .container .checkmark:after {
  left: 7px;
  top: 3px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
#deleteBrModal .container.radio {
  width: fit-content !important;
  padding: 0 50px;
}
#deleteBrModal .checkmark {
  margin-left: -26px;
  margin-top: 3px;
}
#deleteBrModal .btn-link {
  color: #5b5b5b;
  font-weight: bold;
}
#deleteBrModal .btn-link:hover {
  text-decoration: none;
  color: #5a5a5a;
}
#deleteBrModal .btn-link:focus {
  text-decoration: none;
}
#deleteBrModal .btn-secondary {
  border-radius: 0;
  background-color: #b4b4b4;
  box-shadow: none !important;
  border: none;
}
#deleteBrModal .btn-primary {
  border-radius: 25px;
  box-shadow: none !important;
  min-width: 100px;
  color: white;
  background-color: #0078dc;
  padding: 4px 19px;
}
@media (min-width: 2024px) {
#deleteBrModal #confirmation-modal-label {
    font-size: 3.2rem;
}
}
#deleteBrModal .invalid-feedback {
  display: block;
}
@media (min-width: 2024px) {
#deleteBrModal .invalid-feedback span {
    font-size: 1.84rem !important;
}
}
@media (min-width: 2024px) {
#deleteBrModal .modal-dialog {
    max-width: 700px !important;
}
}
@media (min-width: 2024px) {
#deleteBrModal .modal-dialog .input-group input {
    font-size: 1.84rem !important;
}
}
@media (min-width: 2024px) {
#deleteBrModal .modal-dialog .modal-footer button.btn {
    font-size: 1.84rem !important;
}
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
